
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { DataTable } from "@/components/ui/data-table";
import { formatDistanceToNow } from "date-fns";
import { fr } from "date-fns/locale";

interface ProductLimit {
  id: string;
  owner_id: string;
  product_limit: number;
  created_at: string;
  updated_at: string;
  profiles: {
    full_name: string | null;
    email: string | null;
  };
  owner_data: {
    company_name: string | null;
  };
}

export const ProductLimitsTable = () => {
  const { data: limits, isLoading } = useQuery({
    queryKey: ["product-limits"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("custom_product_limits")
        .select(`
          *,
          profiles (
            full_name,
            email
          ),
          owner_data (
            company_name
          )
        `)
        .order("created_at", { ascending: false });

      if (error) {
        console.error("Erreur lors de la récupération des limites:", error);
        throw error;
      }

      return data as ProductLimit[];
    },
  });

  const columns = [
    {
      id: "owner",
      label: "Propriétaire",
      cell: (row: ProductLimit) => (
        <div>
          <p className="font-medium">{row.owner_data?.company_name || "N/A"}</p>
          <p className="text-sm text-muted-foreground">{row.profiles?.full_name}</p>
          <p className="text-sm text-muted-foreground">{row.profiles?.email}</p>
        </div>
      ),
    },
    {
      id: "limit",
      label: "Limite de produits",
      cell: (row: ProductLimit) => (
        <span className="font-medium">
          {row.product_limit === -1 ? "Illimité" : row.product_limit}
        </span>
      ),
    },
    {
      id: "updated_at",
      label: "Dernière mise à jour",
      cell: (row: ProductLimit) => (
        <span className="text-muted-foreground">
          {formatDistanceToNow(new Date(row.updated_at), { 
            addSuffix: true,
            locale: fr 
          })}
        </span>
      ),
    },
  ];

  return <DataTable columns={columns} data={limits || []} />;
};
